import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { useCompanySearchItemsStore } from '@aibees/elephant/feature/search-table-company/store';
import { useMemo } from 'react';

export function useEmployeeCardHeaderData() {
  const { companySearchItems } = useCompanySearchItemsStore();
  const { selectedItemId } = useSearchFiltersStore();

  const currentItem = useMemo(() => {
    if (
      !companySearchItems ||
      companySearchItems.length === 0 ||
      !selectedItemId
    ) {
      return undefined;
    }

    const itemIndex = companySearchItems.findIndex(
      (item) => item.id === selectedItemId
    );

    return itemIndex !== -1 ? companySearchItems[itemIndex] : undefined;
  }, [companySearchItems, selectedItemId]);

  return { currentItem };
}
